import script from "./EditIndividualBusinessPageTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditIndividualBusinessPageTab.vue?vue&type=script&setup=true&lang=ts"

import "./EditIndividualBusinessPageTab.vue?vue&type=style&index=0&id=1204a484&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1204a484"]])

export default __exports__